import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useRef, useMemo } from "react";
import { useDefaultCenter } from "../../../hooks/defaultcenter";
import { GeoMap } from "../../GeoMap";
import { GeoSearchBar } from "../../GeoSearchBar";

export const FaultLocationStep = () => {
  const { defaultLatitude, defaultLongitude } = useDefaultCenter();
  const stepRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const geocoder = useRef<google.maps.Geocoder>(new google.maps.Geocoder());
  useMemo(() => {
    const location: google.maps.LatLngLiteral = {
      lat: Number(defaultLatitude),
      lng: Number(defaultLongitude),
    };

    let cityName: string = "";

    geocoder.current.geocode({ location, componentRestrictions: {}, }).then(response => {
      cityName = response.results
        .filter((result) => result.types.includes("locality"))
        .map((result) => result.address_components)
        .filter((components) => components.filter((component) => component.types.includes("locality")))
        .shift()
        ?.map((component) => component.short_name)
        .shift() || "";
    }).catch(console.error)

    return cityName;
  }, [defaultLatitude, defaultLongitude]);
  const setDefaultLocation = async () => {

    
  };

  useEffect(() => {

    setDefaultLocation();
  }, [defaultLatitude, defaultLongitude]);

  // Scroll to top when this step mounts
  useEffect(() => {
    stepRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <Box ref={stepRef} display="flex" flexDirection="column" flex={1} width="100%">
      <Typography
        
        variant="h2"
        sx={{
          maxWidth: { xs: '100%', sm: '80%' },
          textAlign: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >{`Bitte wählen Sie die betreffende Straßenleuchte aus`}</Typography>
      <GeoSearchBar layout="row" />
      <GeoMap
        defaultFetchType="defaultCenter"
        style={isMobile ? geoMapStyleMobile : geoMapStyle} 
        elevation={0}
      />
    </Box>
  );
};

const geoMapStyle = { flex: 1, minHeight: 400, width: "100%" };
const geoMapStyleMobile = { flex: 1, minHeight: '55vh', width: "100%", marginTop: '8px' };

export default FaultLocationStep;
